import React from 'react'
import '../Styles/components/customValidationMessage.scss';
import { Message } from 'primereact/message';

export const CustomValidationMessage = ({ text, className = "", severity, ...props }) => {

    return <Message text={text}
        className={`info_detail ${className}`.trim()}
        severity={severity}
        {...props} />;
}


export const CustomInfoMessage = ({ severity = 'info', summary, detail }) => {
    return (
        <div className={`custom-message ${severity}`}>
            <div className="summary">{summary}</div>
            <div className="detail">{detail}</div>
        </div>
    );
};
